import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';

export interface PeriodCloseListDto {
  id: string;
  financialYearCode: string;
  financialPeriodCode: string;
  module: string;
  status: string;
  closeType?: string | null;
  closingDate?: string | null;
  workflowStatus: string;
  createdDate: string;
}

export interface PeriodCloseFilter {
  page?: number;
  pageSize?: number;
  companyId?: string;
  /** The server filters on financialPeriodCode; `periodCode` matched nothing. */
  financialPeriodCode?: string;
  financialYearCode?: string;
  module?: string;
  status?: string;
}

export const periodClosingApi = {
  /** GET /api/v1/period-closing */
  getList: (filter?: PeriodCloseFilter) =>
    apiClient.get<ApiResponse<PagedResult<PeriodCloseListDto>>>('/period-closing', { params: filter }),
  /** GET /api/v1/period-closing/{id} */
  getById: (id: string) =>
    apiClient.get<ApiResponse<PeriodCloseListDto>>(`/period-closing/${id}`),
  /** POST /api/v1/period-closing */
  create: (data: unknown) =>
    apiClient.post<ApiResponse<PeriodCloseListDto>>('/period-closing', data),
  /** POST /api/v1/period-closing/{id}/close */
  close: (id: string, data: unknown) =>
    apiClient.post<ApiResponse<PeriodCloseListDto>>(`/period-closing/${id}/close`, data),
  /** POST /api/v1/period-closing/{id}/reopen */
  reopen: (id: string, data: unknown) =>
    apiClient.post<ApiResponse<PeriodCloseListDto>>(`/period-closing/${id}/reopen`, data),
  /** POST /api/v1/period-closing/{id}/submit */
  submit: (id: string) =>
    apiClient.post<ApiResponse<PeriodCloseListDto>>(`/period-closing/${id}/submit`),
  /** POST /api/v1/period-closing/{id}/approve */
  approve: (id: string) =>
    apiClient.post<ApiResponse<PeriodCloseListDto>>(`/period-closing/${id}/approve`),
};
